import '@shared/Filters'
import '@shared/Directives'
import './Components'

import axios from 'axios'
import Echo from 'laravel-echo'
import { getStorage, setStorage } from '@builder-web/Utilities'

window.Pusher = require('pusher-js')

window.Echo = new Echo({
    forceTLS: true,
    broadcaster: 'pusher',
    bearerToken: getStorage('token'),
    key: process.env.VUE_APP_PUSHER_APP_KEY,
    cluster: process.env.VUE_APP_PUSHER_APP_CLUSTER,
    authEndpoint: `${process.env.VUE_APP_API_HOST}/api/broadcasting/auth`,
})

axios.interceptors.request.use(
    function (config) {
        const token = getStorage('token')

        if (config.skipInterceptor || !token) {
            return config
        }

        config.headers.Authorization = `Bearer ${token}`
        return config
    },
    (error) => Promise.reject(error),
)

axios.interceptors.response.use(
    (response) => {
        const expires = response.headers['x-token-expires'] || null
        const token = getStorage('token') || null

        if (expires && token) {
            const expiryTime = parseInt(expires) * 86400000
            setStorage('token', token, expiryTime)
        }

        return response
    },
    (error) => Promise.reject(error),
)
